import { theme } from "../../../../theme";
export const calendarStyles = {
    borderRadius: 10,
};
export const calendarTheme = {
    textDayFontFamily: "Proxima",
    textMonthFontFamily: "ProximaBold",
    textDayHeaderFontFamily: "Proxima",
    todayTextColor: theme.colors.dark.base,
    textDisabledColor: theme.colors.greyscale.lightest,
    dayTextColor: theme.colors.dark.base,
    textDayFontSize: theme.fontDefaults.xsmall.fontSize,
    arrowColor: theme.colors.brand.base,
    textMonthFontSize: theme.fontDefaults.xsmall.fontSize,
    "stylesheet.calendar.main": {
        dayContainer: {
            margin: 2,
        },
        week: {
            marginVertical: 0,
            flexDirection: "row",
            justifyContent: "space-around",
        },
    },
};
//# sourceMappingURL=InputDate.styles.js.map